import { Box } from '@chakra-ui/react';
import { CameraFlow } from 'components/camera';

export function CameraScreen() {
  return (
    <Box position="relative" minH="100vh" bg="white">
      <CameraFlow />
    </Box>
  );
}
